import { Helmet } from 'react-helmet';
import Footer from '../../components/light/modern-agency/Footer';
import Lines from '../../components/light/common/Lines';
import ProgressScroll from '../../components/light/common/ProgressScroll';
import Cursor from '../../components/light/common/cusor';
import LoadingScreen from '../../components/light/common/loader';
import SecNavbar from '../../components/light/services-details/SecNavbar';
// import Testimonials from '../../components/light/FAQS/Testimonials';
import TermsDetails from '../../components/light/services-details/Terms';
import TermHeader from '../../components/light/services-details/TermHeader';
// import Services from '../../components/light/services-details/Services';
// import Process from '../../components/light/services-details/Process';
// import Services2 from '../../components/light/services-details/Services2';
// import FAQS from '../../components/light/services-details/FAQS';
export default function Terms() {
  return (
    <>
      <Helmet>
        <title>Aashway | Terms & Conditions</title>
        <link rel="icon" href="/light/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/light/imgs/favicon.ico" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/satoshi.css"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght..200;300;400;500;600;700&display=swap"
        />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <SecNavbar />
          <div id="smooth-content">
            <main className="main-bg">
              <TermHeader />
              <TermsDetails />
              {/* <Process />
              <Testimonials />
              <Services2 />
              <FAQS /> */}
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}
